<template>
  <div class="wrap-row">
    <!-- <div class="wrap">
      <img class="logo" :src="TitleLogo" alt="" />
    </div> -->
    <!-- <div class="app">
      {{ $t('JumpMarket.TItle') }}
    </div> -->
    <!-- <div class="intelligentLife">
      <p>{{ $t('JumpMarket.simpleness') }}</p>
      <p>{{ $t('JumpMarket.oneKey') }}</p>
    </div> -->
    <div class="PhoneModel">
      <img
        class="DeviceType === 'IOS' || DeviceType === 'Android' ? PhoneModeling : Modeling"
        src="./upload.jpg"
        alt=""
      />
      <div>
        <van-button @click="download" class="downloadBtn">{{ $t('JumpMarket.btn') }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
// import { DeviceType } from '@/api/native'
export default {
  name: 'JumpMarket',
  data() {
    return {
      TitleLogo: require('./logo.png'),
      anPhotoing: require('./upload.jpg'),
      PhoneModeling: require('./upload.jpg'),
      DeviceType: ''
    }
  },
  mounted() {
    var u = navigator.userAgent
    if (u.match(/Android/i) != null) {
      return (this.DeviceType = 'Android')
    } else if (u.match(/iPhone|iPad|ios/i) != null) {
      return (this.DeviceType = 'IOS')
    }
  },
  methods: {
    download() {
      console.log('[ this.DeviceType ]', this.DeviceType)
      if (this.DeviceType == 'Android') {
        if (navigator.language == 'zh-CN') {
          // const src = 'https://file.noesisrobotic.com/web/operate/apk/noesishome.apk'
          // window.open(src)
          alert('The overseas Google Play download link has not been opened yet, so stay tuned.')
        } else {
          const src = 'https://play.google.com/store/apps/details?id=com.bissell.readyclean&hl=en_US&gl=US'
          window.open(src)
          // alert('The overseas Google Play download link has not been opened yet, so stay tuned.')
        }
      } else if (this.DeviceType == 'IOS') {
        if (navigator.language == 'zh-cn') {
          // const src = 'https://apps.apple.com/cn/app/id1540534954'
          // window.open(src)
          document.write('The overseas App Store download link is not yet open, so stay tuned.')
        } else {
          // alert('The overseas App Store download link is not yet open, so stay tuned.')
          const src = 'https://apps.apple.com/us/app/readyclean-by-bissell/id1615890146'
          window.open(src)
        }
      } else {
        alert('Please download on mobile')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap-row {
  .PhoneModel {
    height: calc(100vh);
    position: relative;
    .PhoneModeling {
      position: absolute;
      top: 0;
      left: 50%;
      height: 100%;
      transform: translate(-50%);
    }
    .Modeling {
      position: absolute;
      top: 0;
      left: 50%;
      height: 100%;
      transform: translate(-50%);
    }
    .downloadBtn {
      z-index: 2;
      position: absolute;
      top: 80%;
      left: 50%;
      transform: translate(-50%);
      background: #133f7a;
      opacity: 1;
      border-radius: 10px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      // line-height: 25px;
      color: #ffffff;
      opacity: 1;
      text-align: center;
      // line-height: 50px;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      user-select: none;
    }
  }
}
</style>
